/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var iconNames = [
	    'angry',
	    'baffled',
	    'confused',
	    'cool',
	    'crying',
	    'evil',
	    'frustrated',
	    'grin',
	    'happy',
	    'hipster',
	    'neutral',
	    'sad',
	    'shocked',
	    'sleepy',
	    'smile',
	    'tongue',
	    'wink',
	    'wondering'
	];
	
	var icons = {};
	
	iconNames.forEach(function(name) {
	    icons[name.toLowerCase()] = __webpack_require__(1)("./" + name + '.svg');
	});
	
	var proto = Object.create(HTMLElement.prototype);
	
	proto.createdCallback = function() {
	    this.innerHTML = icons[('' + this.getAttribute('type')).toLowerCase()];
	};
	
	proto.attributeChangedCallback = function(attributeName, previousValue, value) {
	    if (attributeName === 'type') {
	        this.innerHTML = icons[('' + this.getAttribute('type')).toLowerCase()];
	    }
	};
	
	document.registerElement('x-icon', { prototype: proto });


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./angry.svg": 2,
		"./baffled.svg": 3,
		"./confused.svg": 4,
		"./cool.svg": 5,
		"./crying.svg": 6,
		"./evil.svg": 7,
		"./frustrated.svg": 8,
		"./grin.svg": 9,
		"./happy.svg": 10,
		"./hipster.svg": 11,
		"./neutral.svg": 12,
		"./sad.svg": 13,
		"./shocked.svg": 14,
		"./sleepy.svg": 15,
		"./smile.svg": 16,
		"./tongue.svg": 17,
		"./wink.svg": 18,
		"./wondering.svg": 19
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1;


/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm6.003 21.398C20.78 22.362 18.55 21 16 21s-4.78 1.362-6.003 3.398l-2.573-1.544C9.174 19.946 12.36 18 16 18s6.827 1.945 8.576 4.854l-2.573 1.544zm1.967-15.64c.134.536-.192 1.08-.728 1.213-.55.14-1.204.38-1.78.668.334.357.538.836.538 1.363 0 1.106-.895 2-2 2s-2-.894-2-2c0-.036 0-.072.003-.108.064-1.483 1.413-2.467 2.55-3.036 1.086-.543 2.16-.814 2.205-.826.536-.134 1.08.192 1.213.728zm-15.94 0c.134-.536.677-.862 1.213-.728.045.01 1.12.283 2.205.826 1.137.57 2.486 1.553 2.55 3.036.002.036.003.072.003.11 0 1.104-.894 2-2 2s-2-.896-2-2c0-.528.205-1.006.538-1.364-.575-.288-1.228-.528-1.78-.667-.535-.133-.86-.676-.727-1.212z\"/></svg>"

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3z\"/><path fill=\"#444\" d=\"M12 13c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1z\"/><path fill=\"#444\" d=\"M11 10c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-2c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM22 13c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1z\"/><path fill=\"#444\" d=\"M21 10c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-2c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zM12 22h8v2h-8v-2z\"/></svg>"

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-8 7c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm2.69 10h2.028c.29 2.266-1.014 4.517-3.25 5.33-2.59.943-5.465-.397-6.408-2.988-.566-1.555-2.29-2.36-3.845-1.793-1.424.517-2.217 2.008-1.906 3.45H7.28c-.29-2.266 1.014-4.517 3.25-5.33 2.59-.943 5.465.397 6.408 2.988.566 1.555 2.29 2.36 3.845 1.793 1.424-.517 2.217-2.008 1.906-3.45z\"/></svg>"

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm9 5c.55 0 1 .45 1 1v3c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2h-4c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V9c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v1h4V9c0-.55.45-1 1-1h6zm-9 16c2.913 0 5.462-1.557 6.86-3.884l1.716 1.03C22.826 24.052 19.64 26 16 26c-1.514 0-2.95-.337-4.236-.94l1.036-1.727c.98.43 2.06.668 3.2.668z\"/></svg>"

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3z\"/><path fill=\"#444\" d=\"M25 12h-4c-.552 0-1-.448-1-1s.448-1 1-1h4c.552 0 1 .448 1 1s-.448 1-1 1zM11 12H7c-.552 0-1-.448-1-1s.448-1 1-1h4c.552 0 1 .448 1 1s-.448 1-1 1zM19 26.75c-.256 0-.512-.098-.707-.293C18.15 26.314 17.373 26 16 26s-2.15.314-2.293.457c-.39.39-1.024.39-1.414 0s-.39-1.024 0-1.414C13.233 24.103 15.2 24 16 24s2.766.102 3.707 1.043c.39.39.39 1.024 0 1.414-.195.195-.45.293-.707.293zM23 18c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 .552-.448 1-1 1zM23 24c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 .552-.448 1-1 1zM9 18c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 .552-.448 1-1 1zM9 24c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 .552-.448 1-1 1z\"/></svg>"

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M20 14c-1.105 0-2-.895-2-2 0-.037 0-.073.003-.11.064-1.482 1.413-2.466 2.55-3.035 1.086-.543 2.16-.814 2.205-.826.536-.135 1.08.19 1.213.727s-.19 1.08-.727 1.213c-.55.14-1.204.38-1.78.667.334.357.538.836.538 1.363 0 1.105-.894 2-2 2zM8.758 9.97c-.536-.134-.862-.677-.728-1.213s.677-.862 1.213-.728c.045.01 1.12.282 2.205.825 1.137.568 2.486 1.553 2.55 3.036.002.037.003.073.003.11 0 1.105-.894 2-2 2s-2-.895-2-2c0-.527.205-1.005.538-1.363-.575-.288-1.23-.528-1.78-.667zM16 23c2.55 0 4.78-1.362 6.003-3.398l2.573 1.544C22.826 24.054 19.64 26 16 26s-6.827-1.945-8.576-4.854l2.573-1.544C11.22 21.638 13.45 23 16 23zM32 2c0-1.422-.298-2.775-.833-4-1.05 2.4-3.014 4.31-5.453 5.287C23.02 1.227 19.654 0 16 0S8.98 1.226 6.286 3.287C3.846 2.31 1.882.4.833-2 .298-.775 0 .578 0 2c0 2.3.777 4.417 2.08 6.106C.758 10.436 0 13.13 0 16c0 8.837 7.163 16 16 16s16-7.163 16-16c0-2.87-.757-5.565-2.08-7.894C31.222 6.416 32 4.3 32 2zM16 29C8.82 29 3 23.18 3 16S8.82 3 16 3s13 5.82 13 13-5.82 13-13 13z\"/></svg>"

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M11.447 8.856c-1.086-.543-2.16-.814-2.205-.826-.536-.134-1.08.192-1.213.728s.19 1.08.727 1.213c.55.14 1.204.38 1.78.668-.334.357-.538.836-.538 1.363 0 1.106.894 2 2 2s2-.894 2-2c0-.036-.002-.072-.004-.108-.063-1.483-1.413-2.467-2.55-3.036z\"/><path fill=\"#444\" d=\"M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zM7.39 25.74c.336.165.712.26 1.11.26h15c.398 0 .775-.094 1.11-.26C22.315 27.767 19.3 29 16 29s-6.316-1.232-8.61-3.26zM8 23.5v-3c0-.27.23-.5.5-.5H12v4H8.5c-.27 0-.5-.23-.5-.5zm6 .5v-4h4v4h-4zm6 0v-4h3.5c.27 0 .5.23.5.5v3c0 .27-.23.5-.5.5H20zm5.74.61c.165-.336.26-.712.26-1.11v-3c0-1.378-1.122-2.5-2.5-2.5h-15C7.122 18 6 19.122 6 20.5v3c0 .398.094.775.26 1.11C4.233 22.315 3 19.3 3 16 3 8.82 8.82 3 16 3s13 5.82 13 13c0 3.302-1.23 6.316-3.26 8.61z\"/><path fill=\"#444\" d=\"M22.757 8.03c-.045.01-1.12.283-2.205.826-1.137.57-2.486 1.553-2.55 3.036-.002.036-.003.072-.003.11 0 1.104.894 2 2 2s2-.896 2-2c0-.528-.205-1.006-.538-1.364.575-.288 1.228-.528 1.78-.667.535-.133.86-.676.727-1.212s-.678-.862-1.214-.728z\"/></svg>"

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zM6 16v2c0 4.4 3.6 8 8 8h4c4.4 0 8-3.6 8-8v-2H6zm6 7.656c-.83-.296-1.59-.776-2.236-1.42C8.626 21.098 8 19.594 8 18h4v5.656zM18 24h-4v-6h4v6zm4.236-1.764c-.645.645-1.407 1.125-2.236 1.42V18h4c0 1.594-.627 3.098-1.764 4.236zM7.042 12c.305 0 .566-.22.616-.522C7.85 10.332 8.835 9.5 9.998 9.5s2.15.832 2.342 1.978c.05.3.31.522.616.522s.566-.22.616-.52c.034-.202.05-.405.05-.605 0-2-1.625-3.625-3.624-3.625s-3.625 1.626-3.625 3.625c0 .2.017.402.05.604.052.3.312.52.617.52zm12 0c.305 0 .566-.22.616-.522.192-1.146 1.177-1.978 2.34-1.978s2.15.832 2.342 1.978c.05.3.31.522.616.522s.566-.22.616-.52c.034-.202.05-.405.05-.605 0-2-1.625-3.625-3.624-3.625s-3.625 1.626-3.625 3.625c0 .2.017.402.05.604.052.3.312.52.618.52z\"/></svg>"

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm0 15.71c3.623 0 7.07-.962 10-2.653C25.545 21.633 21.215 26 16 26S6.456 21.627 6 16.05c2.93 1.69 6.377 2.658 10 2.658zM8 11c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3zm12 0c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3z\"/></svg>"

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-8 7c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2z\"/><path fill=\"#444\" d=\"M21.12 16.88c-1.17-1.173-3.07-1.173-4.242 0s-1.172 3.07 0 4.242c.038.038.076.074.115.11C19.697 23.683 26 21.17 26 18c-1.94 1.25-3.453.305-4.88-1.122zM10.88 16.88c1.17-1.173 3.07-1.173 4.242 0s1.172 3.07 0 4.242c-.038.038-.076.074-.115.11C12.303 23.683 6 21.17 6 18c1.94 1.25 3.453.305 4.88-1.122z\"/></svg>"

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-8 7c0 1.105.895 2 2 2s2-.895 2-2-.895-2-2-2-2 .895-2 2zm12 0c0 1.105.895 2 2 2s2-.895 2-2-.895-2-2-2-2 .895-2 2zm-8 12h8v2h-8v-2z\"/></svg>"

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-8 7c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zM9.997 24.398l-2.573-1.544C9.174 19.946 12.36 18 16 18s6.827 1.945 8.576 4.854l-2.573 1.544C20.78 22.362 18.55 21 16 21s-4.78 1.362-6.003 3.398z\"/></svg>"

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-4 19c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm8-11c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3zM8 11c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3z\"/></svg>"

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3z\"/><path fill=\"#444\" d=\"M20 21c0 2.76-1.79 5-4 5s-4-2.24-4-5 1.79-5 4-5 4 2.24 4 5zM13 10.625c-.256 0-.512-.098-.707-.293-.604-.604-1.982-.604-2.586 0-.39.39-1.024.39-1.414 0s-.39-1.024 0-1.414c1.392-1.392 4.023-1.392 5.414 0 .39.39.39 1.024 0 1.414-.195.195-.45.293-.707.293zM23 10.625c-.256 0-.512-.098-.707-.293-.604-.604-1.982-.604-2.586 0-.39.39-1.024.39-1.414 0s-.39-1.024 0-1.414c1.392-1.392 4.023-1.392 5.414 0 .39.39.39 1.024 0 1.414-.195.195-.45.293-.707.293z\"/></svg>"

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-8 7c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm2.003 9.602l2.573 1.544C22.826 24.054 19.64 26 16 26s-6.827-1.945-8.576-4.854l2.573-1.544C11.22 21.638 13.45 23 16 23s4.78-1.362 6.003-3.398z\"/></svg>"

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-8 7c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm4 8v2h-2v3c0 1.657-1.343 3-3 3s-3-1.343-3-3v-3H8v-2h16z\"/></svg>"

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm.96 19.22c4.384-.866 7.786-2.86 9.015-5.52-.677 5.25-5.047 9.3-10.34 9.3-3.725 0-6.995-2.01-8.84-5.03 2.2 1.72 6.08 2.056 10.166 1.25zM20 11c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3zm-9 .61c-1.306 0-2.417.488-2.83 1.17C8.06 12.6 8 11.777 8 11.57c0-.97 1.343-1.758 3-1.758s3 .787 3 1.758c0 .206-.06 1.028-.17 1.21-.413-.682-1.523-1.17-2.83-1.17z\"/></svg>"

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm7.304 15.8l.703 2.4-13.656 4-.702-2.4zM8 10c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2z\"/></svg>"

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** icons.min.js
 **/